module.exports = __webpack_public_path__ + "static/media/Logo.fdbb71f7.svg";